import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from "react";

// Layout
import ProtectedRoute from "./ProtectedRoutes";
import AuthLayout from "../layouts/AuthLayout";
import Loader from "../components/Common/Loader";

// Pages
const LogIn = lazy(() => import("../pages/Authentication/LogIn"));
const LogOut = lazy(() => import("../pages/Authentication/LogOut"));
const ResetPassword = lazy(
  () => import("../pages/Authentication/ResetPassword"),
);
const ForgotPassword = lazy(
  () => import("../pages/Authentication/ForgotPassword"),
);
const Register = lazy(() => import("../pages/Authentication/Register"));
const NotFound = lazy(() => import("../pages/404"));

// Check-in
const Monday = lazy(() => import("../pages/CheckIn/Monday"));
const Wednesday = lazy(() => import("../pages/CheckIn/Wednesday"));
const Friday = lazy(() => import("../pages/CheckIn/Friday"));
const CheckInDashboard = lazy(() => import("../pages/CheckIn"));
const CheckInInsights = lazy(() => import("../pages/CheckIn/Insights"));

// Dashboard
// const ClientDashboard = lazy(() => import("../pages/Dashboard/Client"));
const PulseCenter = lazy(() => import("../pages/Dashboard/PulseCenter"));
const Resource = lazy(() => import("../pages/Resources"));
const ChatBot = lazy(() => import("../pages/Chatbot/index"));
const MyInsights = lazy(() => import("../pages/MyInsights"));
const MyAnswers = lazy(() => import("../pages/CheckIn/Answers"));

// Profile
const Profile = lazy(() => import("../pages/Profile"));

const AppRoutes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Router>
        <Routes>
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<PulseCenter />} />
            <Route path="/resources/:id" element={<Resource />} />
            <Route path="/chatbot/:type" element={<ChatBot />} />
            <Route path="/check-in" element={<CheckInDashboard />} />
            <Route path="/check-in/answers" element={<MyAnswers />} />
            <Route path="/check-in/insights" element={<CheckInInsights />} />
            <Route path="/my-insights" element={<MyInsights />} />

            {/* Profile */}
            <Route path="/settings" element={<Profile />} />
          </Route>

          {/* Authentication Routes */}
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LogIn />} />
            <Route path="/logout" element={<LogOut />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/forgot-password/" element={<ForgotPassword />} />
            <Route path="/register" element={<Register />} />
          </Route>

          {/* Check-in */}
          <Route path="/check-in/monday" element={<Monday />} />
          <Route path="/check-in/wednesday" element={<Wednesday />} />
          <Route path="/check-in/friday" element={<Friday />} />

          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default AppRoutes;
